import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { EMarketingParam, EUtmParam } from '~/features/marketing/store'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { store } from '~/store'

function useStoreTrackingParams() {
  const [searchParams] = useSearchParams()
  const [setUtmParams, setMarketingParams, setPartnerUtmParams] = store(
    (state) => [
      state.setUtmParams,
      state.setMarketingParams,
      state.setPartnerUtmParams,
    ],
  )
  const { partner } = usePartnerCentralized()

  useEffect(() => {
    function updateParamsStore(
      searchParamKeys: string[],
      storeUpdateFn: (params: Record<string, string>) => void,
    ) {
      const params: Record<string, string> = {}

      searchParamKeys.forEach((searchParamKey) => {
        const searchParam = searchParams.get(searchParamKey)
        if (searchParam) {
          params[searchParamKey] = searchParam
        }
      })

      storeUpdateFn(params)
    }

    const utmParamKeys = Object.values(EUtmParam)
    const marketingParamKeys = Object.values(EMarketingParam)
    const partnerAllowedQueryParams = partner.allowedQueryParams

    updateParamsStore(utmParamKeys, setUtmParams)
    updateParamsStore(marketingParamKeys, setMarketingParams)
    updateParamsStore(partnerAllowedQueryParams, setPartnerUtmParams)
  }, [
    searchParams,
    setUtmParams,
    setMarketingParams,
    setPartnerUtmParams,
    partner,
  ])
}

export default useStoreTrackingParams
